import './mobile-nav';
import './social-share';
import './header';
import './navigation';
import './table-filters';
import './preview-objects';
import './map';

import initExportMenu from './export';
import partyColors from './party-colors/party-colors';


window.SFP = {
    initExportMenu: initExportMenu,
    partyColors: partyColors
};
